<template>
<div class="edit-area">
  <div class="preview-dialog"
    ref="previewDialog">
    <div class="preview-tabs"
        ref="previewViewerTab">
      <div id="preview-viewer"
        class="preview-viewer tab-content"
        :style="previewViewerCss"
        ref="previewViewer">
        <div class="doc-paper preview keirekisho"
         :style="scaleStyle"
        ref="previewViewerHeight">
          <div class="keirekisho-wapper">
            <div class="keirekisho-header">
              <h1 class="title">소개·추천서</h1>
              <div class="date data text-right">
                <span v-html="formatedNowDate"></span>
              </div>
              <div class="data text-right">
                <span class="name">{{ introData.request_name }}</span>
              </div>
            </div>
          </div>

          <div v-for="(item, index) in introData.intro_info"
              v-bind:class="item.classObject"
              :key="index"
              v-if="item.display_flag == 'Y'"
           class="keirekisho-content">
            <div v-if="item.intro_text">
              <h2>{{item.intro_name}}</h2>
              <div style="text-align:right;">
                {{item.intro_pr}}　<br>
                {{item.intro_email}}
              </div>
              <div class="job-summary">
                <pre>{{item.intro_text}}</pre>
              </div>
            </div>
          </div>
          <div class="data text-right">
            <span class="name"><br>경의</span>
          </div>
        </div>
      </div>
    </div>

    <div class="preview-action" v-if="$firebase.isAuthenticated">
      <div class="container-base">
        <ul>
          <li>
            <el-button id="pdf-download-preview"
              class="button-block"
              type="primary"
              :disabled="!$deviceLib.isOnline || !mailPDFSending"
              v-ripple
              @click="$eventHub.$emit('email-PDF'); mailPDFSending = false"><i class="el-icon-message"></i> 메일로 PDF전송</el-button>
          </li>
          <li >
            <el-button id="pdf-download-preview"
              class="button-block"
              style="background-color:#fce8ef;border-color:#f4a2be;color:#e3165c"
              type="primary"
              :disabled="!$deviceLib.isOnline || !downloadPdfEnabled"
              v-ripple
              @click="$eventHub.$emit('download-PDF'); downloadPdfEnabled = false"><i class="el-icon-download"></i> PDF다운로드</el-button>
          </li>
        </ul>
      </div>
    </div>

  </div>

</div>
</template>
<style lang="scss" src="@/assets/scss/formats.scss"></style>
<script>
import basicInfo from '@/components/BasicInfo'
import ShokurekishoPreviewMixin from '@/mixins/shokurekisho-preview-mixin'
import timeAgo from '@/assets/lib/time-ago-jp'
import _ from '@/assets/lib/my-lodash'
const RECENT_EDIT_SAVE_KEY = 'recentEdit'
const LAST_SAVE_DATE_SAVE_KEY = 'lastSaveDate'
// 書式1枚の高さ
const DOC_PAPER_WIDTH_PX = 794

export default {
  props: {
    formatId: {
      type: String
    },
    preview: {
      type: Boolean,
      default: false
    },
    accessId: {
      type: String
    }
  },
  mixins: [ShokurekishoPreviewMixin],
  data: function () {
    return {
      formatInfo: {},
      introData: {},
      basicInfo: basicInfo,
      requiredBasicFields: [],
      previewHtml: '',
      lastName: '金',
      firstName: '起満',
      previewDialogVisible: true,
      previewViewerCss: {},
      previewTabActive: 'previewFormat',
      mailPDFSending: true,
      saveNotifyMessage: '',
      saveNotifyMessageUpdateTimer: null,
      saveDate: null,
      devAreaVisible: false,
      currentFormat: {},
      downloadPdfEnabled: true,
      pdfBlob: null
    }
  },
  computed: {
    formatedNowDate: function () {
      return this.$formLib.dateFormat(this.$formLib.getToday(), 'yyyy년 m월 d일')
    },
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      this.updatePreviewHTML()
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    },
    getMode: function () {
      return process.env.VUE_APP_MODE
    }
  },
  methods: {
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}introduction${dateString}.${ext}`
    },
    setPreviewScaleDebounce: function (e) {
      _.debounce(this.setPreviewScale, 1000)
    },
    setPreviewScale: function () {
      this.$nextTick(function () {
        if (this.previewTabActive === 'sampleFormat') {
          const clientWidth = this.$refs[this.previewTabActive].$el.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        } else {
          const clientWidth = this.$refs.previewViewer.clientWidth
          this.previewScale = clientWidth / Math.max(clientWidth, DOC_PAPER_WIDTH_PX)
        }
        this.$nextTick(function () {
          this.setPreviewHeight()
        })
      })
    },
    setPreviewHeight: function () {
      const height = this.$refs.previewViewerHeight.getBoundingClientRect().height
      console.error(height)
      if (!height) {
        return
      }
      this.previewViewerCss = {
        height: height + 30 + 'px'
      }
    },
    updatePreviewHTML: function () {
      this.previewHtml = this.$refs.previewViewer.innerHTML
    },
    downloadPDFWithLink: function () {
      console.error(this.$refs.previewViewer.innerHTML)
      const previewOpened = this.previewDialogVisible
      if (!previewOpened) {
        this.previewDialogVisible = true
      }
      const filename = this.createFilename('pdf')
      const app = this
      this.$nextTick(function () {
        this.updatePreviewHTML()
        const formData = this.pdfFormData
        formData.append('version', '2')
        formData.append('format_id', app.formatId)
        formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        formData.append('uuid', app.$firebase.user.uid)
        this.$axios({
          url: this.$varuna.endPoints.pdf + filename,
          method: 'post',
          data: formData,
          responseType: 'blob',
          timeout: 40000
        }).then((response) => {
          const pdfBlob = new Blob([response.data], {
            type: 'application/pdf'
          })
          if (app.$deviceLib.isMobileDevice) {
            const url = window.URL.createObjectURL(pdfBlob)
            let link = document.createElement('a')
            link.href = '/download?filename='+filename+'&blob=' + url
            link.target = '_blank'
            console.error(link)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          } else {
            const url = window.URL.createObjectURL(pdfBlob)
            // saveDownloadLog(pdfBlob, filename)
            let link = document.createElement('a')
            link.href = url
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
          }
        }).catch(function (error) {
          app.$message({
            message: '다운로드를 실패 하였습니다. 잠시후 다시 시도해주세요.',
            type: 'error'
          })
          app.downloadPdfEnabled = true
          console.error(error)
          app.$gtm.sendError('pdf download', `download pdf failed ${error}`)
        })
      })
      if (!previewOpened) {
        this.previewDialogVisible = false
      }
      
    },
    mailPDF: async function () {
      const app = this
      // alert('システムメンテナンス中です。サービス再開までしばらくお待ちください。再開はお知らせにて掲載いたします。')
      // return
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '오프라인입니다. 인터넷에 접속 해주세요.',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken) {
        this.$message({
          message: '로그인 해주세요.',
          type: 'warning'
        })
        return
      }
      if (this.mailPDFSending) {
        this.$message({
          message: '메일을 전송하고 있습니다.',
          type: 'error'
        })
        return
      }
      if (!this.$firebase.user.email) {
        if (!app.basicData.email) {
          this.$message({
            message: '연락처에 메일주소를 입력 해주세요.',
            type: 'error'
          })
          return
        }
      } else {
        if (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && !app.basicData.email) {
          this.$message({
            message: '연락처에 메일주소를 입력 해주세요.',
            type: 'error'
          })
          return
        }
      }
      this.updatePreviewHTML()
      this.mailPDFSending = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      // formData.append('format_id', this.formatId)
      formData.append('format_id', 'recommend')
      if (!this.$firebase.user.email && app.basicData.email || 
        (this.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
        formData.append('inputemail', app.basicData.email)
        const subformData = new FormData()
        subformData.append('uuid', this.$firebase.user.uid)
        subformData.append('email', app.basicData.email)
        subformData.append('app_flag', this.$site.appFlag)
        subformData.append('site_flag', 'c')
        subformData.append('email_verified', this.$firebase.useremailVerified?'1':'0')
        subformData.append('device_flag', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
        this.$axios
          .post(this.$varuna.endPoints.login, subformData)
        // this.$firebase.user.updateEmail(app.basicData.email).then(() => {
        // }).catch((error) => {
        // });
      }
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('yaginame', this.$yagi.profile.name)
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('version', '2')
      this.$axios
        .post(this.$varuna.endPoints.mailIntroductionPdf, formData, {timeout: 60000})
        .then(function (response) {
          if (!app.$firebase.user.email && app.basicData.email || 
            (app.$firebase.user.email.indexOf('@privaterelay.appleid.com') > 0 && app.basicData.email)) {
            app.$message({
              message: app.basicData.email + '에 전송 하였습니다.',
              type: 'success'
            })
          } else {
            app.$message({
              message: app.$firebase.user.email + '에 전송 하였습니다.',
              type: 'success'
            })
          }
        })
        .catch(function (error) {
          app.$message({
            message: '전송을 실패하였습니다.',
            type: 'error'
          })
          console.error(error)
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.mailPDFSending = false
        })
    },
    downloadPDF: function () {
      const app = this
      if (this.$deviceLib.isIE) {
        this.downloadPDFWithForm(true)
      } else {
        this.downloadPDFWithLink()
      }
    }
  },
  watch: {
  },
  beforeMount: function () {
  },
  beforeDestroy() {
  },
  created: function () {
    console.log(this.accessId)
    const app = this
    const formData = new FormData()
    formData.append('access_id', this.accessId)
    formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
    formData.append('version', '2')
    formData.append('reqflg', '2')

    this.$axios
      .post(this.$varuna.endPoints.getIntroduction, formData, {timeout: 60000})
      .then(function (response) {
        app.introData = response.data
        app.setPreviewScale()
        app.$message({
          duration: 0,
          showClose: true,
          dangerouslyUseHTMLString: true,
          message: `데이터를 취득 하였습니다.`,
          type: 'info'
        })
      })
      .catch(function (error) {
        app.$message({
          duration: 0,
          showClose: true,
          message: '취득을 실패하였습니다.',
          type: 'error'
        })
      }).finally(function () {
        
      })
  },
  mounted: function () {
    this.$eventHub.$on('email-PDF', this.mailPDF)
    this.$eventHub.$on('download-PDF', this.downloadPDF)
    window.addEventListener('resize', this.setPreviewScaleDebounce, false)
  },
  destroyed: function () {
    this.$eventHub.$off('email-PDF', this.mailPDF)
    this.$eventHub.$off('download-PDF', this.downloadPDF)
    window.removeEventListener('resize', this.setPreviewScaleDebounce, false)
  }
}
</script>
